import { useState } from 'react';
import { navItems, siteMeta } from '@/mocks/homeData';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full bg-foreground-950 text-background-50">
        <div className="flex items-center justify-between gap-4 px-4 py-1.5 text-[11px] md:px-8 md:text-xs">
          <div className="flex flex-wrap items-center gap-2">
            <span className="flex items-center gap-1.5">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-time-line" />
              </span>
              黑料六点档 · {siteMeta.updateText}
            </span>
            <span className="hidden text-background-50/40 sm:inline">|</span>
            <span className="hidden sm:inline">今日已整理 {siteMeta.todayCount} 条专题</span>
          </div>
          <div className="hidden items-center gap-4 md:flex">
            <span className="flex items-center gap-1.5">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-eye-line" />
              </span>
              在线围观 {siteMeta.onlineCount}
            </span>
            <a href="#submit" className="whitespace-nowrap text-accent-300 transition-colors hover:text-accent-200">
              投稿入口 →
            </a>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between gap-6 px-4 py-3 md:px-8">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            六
          </span>
          <h1 className="whitespace-nowrap font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            黑料六点
            <span className="ml-1 align-top text-xs text-primary-600">档</span>
          </h1>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#topics"
            className="whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            栏目目录
          </a>
          <a
            href="#submit"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-upload-2-line" />
            </span>
            投稿入口
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航"
          onClick={() => setMenuOpen((prev) => !prev)}
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:border-primary-300 md:hidden"
        >
          <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-3-line text-lg'} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-700"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#submit"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-upload-2-line" />
            </span>
            投稿入口
          </a>
        </div>
      )}
    </header>
  );
}